export const isImage = (contentType: string) => contentType.startsWith('image/');
export const isCsv = (contentType: string) => contentType === 'text/csv';
export const isExcel = (contentType: string) =>
  contentType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
  contentType === 'application/vnd.ms-excel';
export const isDocx = (contentType: string) =>
  contentType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

export function getFileTypeBadge(contentType: string): string {
  if (isImage(contentType)) return 'Image';
  if (isCsv(contentType)) return 'CSV';
  if (isExcel(contentType)) return 'Excel';
  if (isDocx(contentType)) return 'Word';
  if (contentType === 'application/pdf') return 'PDF';
  return 'File';
}

export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
}
